import {connect} from "react-redux";
import {SLQ_USERS_LOAD, SLQ_USERS_UNLOAD} from "../../constants/actionTypes";
import React, {useEffect, useRef, useState} from "react";
import agent from "../../agent";
import {TabPanel, TabView} from "primereact/tabview";
import {Fieldset} from "primereact/fieldset";
import {history} from "../../store";
import {trim} from "../../utils/util";
import UserFilter from "./SQLUsers/filters/UserFilter";
import AvrJurFilter from "./SQLUsers/filters/AvrJurFilter";
import AvrPhysFilter from "./SQLUsers/filters/AvrPhysFilter";
import AvrPtcFilter from "./SQLUsers/filters/AvrPtcFilter";
import PassPayFilter from "./SQLUsers/filters/PassPayFilter";
import UserTable from "./SQLUsers/Table/UserTable";
import AvrJurTable from "./SQLUsers/Table/AvrJurTable";
import AvrPhysTable from "./SQLUsers/Table/AvrPhysTable";
import AvrPtcTable from "./SQLUsers/Table/AvrPtcTable";
import PassPayTable from "./SQLUsers/Table/PassPayTable";
import AvrJurActionBar from "./SQLUsers/actions/AvrJurActionBar";
import AvrPhysActionBar from "./SQLUsers/actions/AvrPhysActionBar";
import AvrPtcActionBar from "./SQLUsers/actions/AvrPtcActionBar";
import WithdrawActionBar from "./SQLUsers/actions/WithdrawActionBar";

const mapStateToProps = (state) => ({
    ...state.slqUser,
});

const mapDispatchToProps = (dispatch) => ({
    onLoad: (payload) => {
        dispatch({type: SLQ_USERS_LOAD, payload});
    },
    onUnload: () => {
        dispatch({type: SLQ_USERS_UNLOAD});
    },
});

const SLQUsers = (props) => {
    console.log("SLQUsers props", props);
    const [first, setFirst] = useState(0);
    const [q, setQ] = useState("");
    const [page, setPage] = useState(0);
    const [pageSize, setPageSize] = useState(10);
    const [realm, setRealm] = useState("slq_jur");
    const [activeIndex, setActiveIndex] = useState(0);
    const [panelCollapsed, setPanelCollapsed] = useState(false);

    const submitForm = (e) => {
        e.preventDefault();
        const form = e.currentTarget;
        const formData = new FormData(form);
        setPage(0)
        // Convert FormData to a plain object for easier logging and usage
        const payload = {};
        for (const [key, value] of formData.entries()) {
            if (value !== undefined && value !== null && String(value).trim() !== "") {
                payload[key] = value;
            }
        }
        const localQ = searchQuery({...payload, page: page + 1, pageSize});
        history.push(
            `/users${localQ.length > 1 ? "?".concat(localQ.substring(1)) : ""}`
        );
        console.log("submitForm activeIndex === 5", payload, activeIndex);
        // Prefer q from the submitted form when provided, fallback to existing state
        if (activeIndex === 0 || activeIndex === 1) {
            props.onLoad(agent.SlqUser.all(realm, filterParam.q, page, pageSize));
        } else if (activeIndex === 2) {
            // Payments APIs expect a single options object. Map pageSize -> itemsPerPage and include page
            props.onLoad(
                agent.Payments.getAllAvrs({
                    ...payload,
                    itemsPerPage: pageSize,
                    page,
                })
            );
        } else if (activeIndex === 3) {
            // Payments APIs expect a single options object. Map pageSize -> itemsPerPage and include page
            props.onLoad(
                agent.Payments.getAllPayments({
                    ...payload,
                    itemsPerPage: pageSize,
                    page,
                })
            );
        } else if (activeIndex === 4) {
            // PassPay remains as-is, assuming existing implementation inside PassPayTable/table's loader
            props.onLoad(
                agent.Payments.getAllWithdraws({
                    ...payload,
                    itemsPerPage: pageSize,
                    page,
                })
            );
        } else if (activeIndex === 5) {
            console.log("submitForm activeIndex === 5", payload);
            props.onLoad(
                agent.Payments.getAllPtcAvrs({
                    ...payload,
                    itemsPerPage: pageSize,
                    page,
                })
            );
        }
    };

    const clearForm = (e) => {
        setPage(0)
        const payload = {};
        setFilterParam({})
        const localQ = searchQuery({...payload, page: 1, pageSize});
        history.push(
            `/users${localQ.length > 1 ? "?".concat(localQ.substring(1)) : ""}`
        );

        if (activeIndex === 0 || activeIndex === 1) {
            props.onLoad(agent.SlqUser.all(realm, '', 0, pageSize));
        } else if (activeIndex === 2) {
            // Payments APIs expect a single options object. Map pageSize -> itemsPerPage and include page
            props.onLoad(
                agent.Payments.getAllAvrs({
                    ...payload,
                    itemsPerPage: pageSize,
                    page: 0,
                })
            );
        } else if (activeIndex === 3) {
            // Payments APIs expect a single options object. Map pageSize -> itemsPerPage and include page
            props.onLoad(
                agent.Payments.getAllPayments({
                    ...payload,
                    itemsPerPage: pageSize,
                    page: 0,
                })
            );
        } else if (activeIndex === 4) {
            // PassPay remains as-is, assuming existing implementation inside PassPayTable/table's loader
            props.onLoad(
                agent.Payments.getAllWithdraws({
                    ...payload,
                    itemsPerPage: pageSize,
                    page: 0,
                })
            );
        } else if (activeIndex === 5) {
            props.onLoad(
                agent.Payments.getAllPtcAvrs({
                    ...payload,
                    itemsPerPage: pageSize,
                    page: 0,
                })
            );
        }
    };

    const [filterParam, setFilterParam] = useState({})

    const onTabChange = (index) => {
        setActiveIndex(index);
        const localRealm = index === 0 ? "slq_jur" : "slq_phys";
        setRealm(localRealm);

        if (activeIndex !== index) {
            setFilterParam({});
        }

        // Prefer q from the submitted form when provided, fallback to existing state
        if (index === 0 || index === 1) {
            props.onLoad(agent.SlqUser.all(localRealm, filterParam.q || '', page, pageSize));
        } else if (index === 2) {
            // Payments APIs expect a single options object. Map pageSize -> itemsPerPage and include page
            props.onLoad(
                agent.Payments.getAllAvrs({
                    ...filterParam,
                    itemsPerPage: pageSize,
                    page,
                })
            );
        } else if (index === 3) {
            // Payments APIs expect a single options object. Map pageSize -> itemsPerPage and include page
            props.onLoad(
                agent.Payments.getAllPayments({
                    ...filterParam,
                    itemsPerPage: pageSize,
                    page,
                })
            );
        } else if (index === 4) {
            // PassPay
            props.onLoad(
                agent.Payments.getAllWithdraws({
                    ...filterParam,
                    itemsPerPage: pageSize,
                    page,
                })
            );
        } else if (index === 5) {
            props.onLoad(
                agent.Payments.getAllPtcAvrs({
                    ...filterParam,
                    itemsPerPage: pageSize,
                    page,
                })
            );
        }
    };

    const formatDate = (val) => {
        if (val) {
            return val.toString().padStart(2, "0");
        }
        return val;
    };

    const searchQuery = (state) => {
        let q = "";
        for (let [key, value] of Object.entries(state)) {
            value = trim(value);
            if (value) {
                if (Array.isArray(value) && !key.includes("status")) {
                    let from = new Date(value[0]);
                    let to = value[1] ? new Date(value[1]) : new Date();
                    value = `${formatDate(from.getDate())}.${formatDate(
                        from.getMonth() + 1
                    )}.${from.getFullYear()}-${formatDate(to.getDate())}.${formatDate(
                        to.getMonth() + 1
                    )}.${to.getFullYear()}`;
                }
                q = !q.includes(`${key}=${value}`)
                    ? (q || "&") + `${key}=${value}&`
                    : "";
            }
        }
        if (q && q.length > 1) {
            q = q.substring(0, q.length - 1);
        }
        return q || "";
    };

    function getFormattedDate(date) {
        let year = date.getFullYear();
        let month = (1 + date.getMonth()).toString().padStart(2, '0');
        let day = date.getDate().toString().padStart(2, '0');

        return `${day}.${month}.${year}`;
    }

    const onPageChange = (event) => {
        setPage(event.page);
        setPageSize(event.rows);
        setFirst(event.first);

        const payload = {};
        for (const key of Object.keys(filterParam)) {
            const value = filterParam[key];
            if (value instanceof Date) {
                payload[key] = getFormattedDate(value);
            }
            else if (value !== undefined && value !== null && String(value).trim() !== "") {
                payload[key] = value;
            }
        }
        const localQ = searchQuery({
            ...payload,
            page: event.page + 1,
            pageSize: event.rows,
        });
        history.push(
            `/users${localQ.length > 1 ? "?".concat(localQ.substring(1)) : ""}`
        );
        if (activeIndex === 0 || activeIndex === 1) {
            props.onLoad(agent.SlqUser.all(realm, payload.q || '', event.page, event.rows));

        } else if (activeIndex === 2) {
            props.onLoad(
                agent.Payments.getAllAvrs({
                    ...payload,
                    itemsPerPage: event.rows,
                    page: event.page,
                })
            );
        } else if (activeIndex === 3) {
            props.onLoad(
                agent.Payments.getAllPayments({
                    ...payload,
                    itemsPerPage: event.rows,
                    page: event.page,
                })
            );
        } else if (activeIndex === 4) {
            // PassPay remains as-is, assuming existing implementation inside PassPayTable/table's loader
            props.onLoad(
                agent.Payments.getAllWithdraws({
                    ...payload,
                    itemsPerPage: event.rows,
                    page: event.page,
                })
            );
        } else if (activeIndex === 5) {
            props.onLoad(
                agent.Payments.getAllPtcAvrs({
                    ...payload,
                    itemsPerPage: event.rows,
                    page: event.page,
                })
            );
        }
    };

    useEffect(() => {
        props.onLoad(agent.SlqUser.all(realm, filterParam.q || '', page, pageSize));

        return function cleanup() {
            props.onUnload();
        };
    }, []);


    return (
        <div>
            <Fieldset
                legend="Поиск"
                toggleable
                collapsed={panelCollapsed}
                onToggle={(e) => setPanelCollapsed(e.value)}
            >
                <FiltersExternal
                    activeIndex={activeIndex}
                    filterParam={filterParam}
                    setFilterParam={setFilterParam}
                    onSubmit={submitForm}
                    onClear={clearForm}
                />
            </Fieldset>
            <ActionBarsExternal
                activeIndex={activeIndex}
                filterParam={filterParam}
                page={page}
                pageSize={pageSize}
            />
            <TabView
                activeIndex={activeIndex}
                onTabChange={(e) => onTabChange(e.index)}
            >
                <TabPanel header="Юр лица">
                    <UserTable
                        page={page}
                        pageSize={pageSize}
                        onPageChange={onPageChange}
                        data={(props.slqUsers || {data: []}).data}
                        totalItems={(props.slqUsers || {totalItems: 0}).totalItems}
                    />
                </TabPanel>
                <TabPanel header="Физ лица">
                    <UserTable
                        page={page}
                        pageSize={pageSize}
                        onPageChange={onPageChange}
                        data={(props.slqUsers || {data: []}).data}
                        totalItems={(props.slqUsers || {totalItems: 0}).totalItems}
                    />
                </TabPanel>
                <TabPanel header="Отчет по АВР">
                    <AvrJurTable
                        page={page}
                        pageSize={pageSize}
                        onPageChange={onPageChange}
                        data={props.slqUsers?.content || []}
                        totalItems={props.slqUsers?.totalElements || 0}
                    />
                </TabPanel>
                <TabPanel header="Отчет по ФЛ">
                    <AvrPhysTable
                        page={page}
                        pageSize={pageSize}
                        onPageChange={onPageChange}
                        data={props.slqUsers?.content || []}
                        totalItems={props.slqUsers?.totalElements || 0}
                    />
                </TabPanel>
                <TabPanel header="Реестр выплат PassPay">
                    <PassPayTable
                        page={page}
                        pageSize={pageSize}
                        onPageChange={onPageChange}
                        data={props.slqUsers?.content || []}
                        totalItems={props.slqUsers?.totalElements || 0}
                    />
                </TabPanel>
                <TabPanel header="Отчет по АВР ЧГП">
                    <AvrPtcTable
                        page={page}
                        pageSize={pageSize}
                        onPageChange={onPageChange}
                        data={props.slqUsers?.content || []}
                        totalItems={props.slqUsers?.totalElements || 0}
                    />
                </TabPanel>
            </TabView>
        </div>
    );
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(SLQUsers);


// Extracted out-of-component to keep a stable component identity across renders
// Prevents remounting of filters (and re-running their mount effects) on each SLQUsers render
const FiltersExternal = React.memo(function FiltersExternal({
                                                                activeIndex,
                                                                filterParam,
                                                                setFilterParam,
                                                                onSubmit,
                                                                onClear,
                                                            }) {
    if (activeIndex === 0 || activeIndex === 1) {
        return (
            <UserFilter
                filterParam={filterParam}
                setFilterParam={setFilterParam}
                onSubmit={onSubmit}
                onClear={onClear}
            />
        );
    } else if (activeIndex === 2) {
        return (
            <AvrJurFilter
                filterParam={filterParam}
                setFilterParam={setFilterParam}
                onSubmit={onSubmit}
                onClear={onClear}
            />
        );
    } else if (activeIndex === 3) {
        return (
            <AvrPhysFilter
                filterParam={filterParam}
                setFilterParam={setFilterParam}
                onSubmit={onSubmit}
                onClear={onClear}
            />
        );
    } else if (activeIndex === 5) {
        return (
            <AvrPtcFilter
                filterParam={filterParam}
                setFilterParam={setFilterParam}
                onSubmit={onSubmit}
                onClear={onClear}
            />
        );
    }
    return (
        <PassPayFilter
            filterParam={filterParam}
            setFilterParam={setFilterParam}
            onSubmit={onSubmit}
            onClear={onClear}
        />
    );
});

// Simple delegator component to render tab-specific ActionBars from separate files
const ActionBarsExternal = React.memo(function ActionBarsExternal({
    activeIndex,
    filterParam,
}) {
    if (activeIndex === 2) {
        return <AvrJurActionBar filterParam={filterParam} />;
    }
    else if (activeIndex === 3) {
        return <AvrPhysActionBar filterParam={filterParam} />;
    }
    else if (activeIndex === 4) {
        return <WithdrawActionBar filterParam={filterParam} />;
    }
    else if (activeIndex === 5) {
        return <AvrPtcActionBar filterParam={filterParam} />;
    }
    return null;
});
